import { HttpResponse, http } from 'msw';
import type { APIResp } from '../../types/APIService';
import { mockedUsers } from '../mocks/API/user.api';
import type { User } from '../../types/User';
import { getAPIUrl } from '../../utils/getApiUrl';

const API_URL = getAPIUrl();
export const usersHandlers = [
  http.get(`${API_URL}users`, () => {
    const res: APIResp<User[]> = { data: mockedUsers, status: 'success', message: '' };
    return HttpResponse.json(res);
  }),
];
